"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = {
  name: 'TableCard',
  props: {
    display: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionOpen: {
      type: Function,
      default: function _default() {}
    },
    updatePage: {
      type: Function,
      default: function _default() {}
    }
  }
};
exports.default = _default2;